import React, { FunctionComponent, useMemo, useState } from "react";
import { Grid, GridSize, Skeleton } from "@mui/material";
import { strings } from "../../../../localization/LocalizedStrings";
import { IMediaGrade, useGetMediaGrades } from "../../../../hooks/mediaGrades";
import { GradeCard } from "../../GradeCard";
import { AttributeDesktop } from "../../AttributeDesktop";
import styles from "./styles.module.scss";
import { attributeIconMap } from "../../../../models/AttributeUtilities";
import { AttributeType } from "../../AttributeList";

export const MediaGradesDesktop: FunctionComponent<IMediaGradesDesktopProps> = ({
  handleClose,
  columnWidth,
  preselectedId,
  onMediaGradeSelected,
  onClearValue
}) => {
  const [loading, setLoading] = useState(false);
  const mediaGrades = useGetMediaGrades(setLoading, []);
  const [searchText, setSearchText] = useState("");
  const filteredMediaGrades = useMemo(() => {
    if (searchText == "") {
      return mediaGrades;
    }
    return mediaGrades?.filter(mediaGrade => {
      return (
        mediaGrade.description.toLowerCase().includes(searchText.toLowerCase()) ||
        +searchText == mediaGrade.points ||
        mediaGrade.goldmineGrade.toLowerCase().includes(searchText.toLowerCase())
      );
    });
  }, [mediaGrades, searchText]);
  return (
    <AttributeDesktop
      handleClose={handleClose}
      isPublic={false}
      items={filteredMediaGrades}
      emptyIconType={attributeIconMap[AttributeType.MEDIA_GRADES]}
      emptyString={strings.empty_media_grades}
      title={strings.attribute_media_grades_title}
      loading={loading}
      setLoading={setLoading}
      onSearchRequested={searchText => setSearchText(searchText)}
      onClearValue={onClearValue}
    >
      {filteredMediaGrades?.map(mediaGrade => (
        <Grid item key={mediaGrade.id} xs={columnWidth}>
          <GradeCard
            points={mediaGrade.points}
            goldmineGrading={mediaGrade.goldmineGrade}
            description={mediaGrade.description}
            selected={preselectedId == mediaGrade.id}
            onClick={() => onMediaGradeSelected?.(mediaGrade)}
          />
        </Grid>
      ))}
      {loading &&
        Array.from({ length: 11 }, (_value, index) => (
          <Grid key={index} item xs={columnWidth}>
            <Skeleton variant={"rectangular"} sx={{ height: 132 }} className={styles.skeleton} />
          </Grid>
        ))}
    </AttributeDesktop>
  );
};

export interface IMediaGradesDesktopProps {
  handleClose?: () => void;
  columnWidth: GridSize;
  preselectedId?: number;
  onMediaGradeSelected?: (mediaGrade: IMediaGrade) => void;
  onClearValue?: () => void;
}
